import { render } from "./VariantDetailsModal.vue?vue&type=template&id=3a157006&scoped=true"
import script from "./VariantDetailsModal.vue?vue&type=script&lang=js"
export * from "./VariantDetailsModal.vue?vue&type=script&lang=js"

import "./VariantDetailsModal.vue?vue&type=style&index=0&id=3a157006&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a157006"]])

export default __exports__